jQuery(document).ready(function($) {

    $( ".bloc_chiffres" ).each(function( index ) {

        var parent = $(this)

        // structure chiffres.php : .chiffres > div > strong (le nombre est le texte du strong)
        // on pre-parse chaque chiffre et on le remet a 0, sinon le nombre final s'affiche avant le compteur
        var chiffres = []

        parent.find(".chiffres strong").each(function () {

            var $this = $(this)
            var raw = $this.text().trim()

            // isole le nombre en gardant prefixe/suffixe (ex: "+150" -> "+", "150 %" -> " %")
            var match = raw.match(/\d[\d\s.,]*\d|\d/)
            if (!match) return   // pas de nombre : on laisse le texte tel quel

            var prefix = raw.slice(0, match.index)
            var suffix = raw.slice(match.index + match[0].length)
            var target = parseInt(match[0].replace(/\D/g, ''), 10)

            if (isNaN(target)) return

            chiffres.push({ $el: $this, raw: raw, prefix: prefix, suffix: suffix, target: target })
            $this.text(prefix + "0" + suffix)   // etat initial : 0
        })

        if (!chiffres.length) return

        gsap.from( parent, {
            scrollTrigger: {
                trigger: parent,
                start: "top bottom",   // demarre des que le haut du bloc atteint le bas du viewport
                markers: false,
                once: true,
                onEnter: self => {

                    chiffres.forEach(function (c) {
                        jQuery({ Counter: 0 }).animate({ Counter: c.target }, {
                            duration: 2000,
                            easing: 'swing',
                            step: function () {
                                c.$el.text(c.prefix + Math.ceil(this.Counter).toLocaleString('fr-FR') + c.suffix);
                            },
                            complete: function () {
                                // on restaure le texte exact saisi par l'editeur
                                c.$el.text(c.raw);
                            }
                        })
                    })

                }
            }

        })
    })

});
